import React from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import Container from 'react-bootstrap/Container';
import Calendar from './Calendar/Calendar';
import Information from './Information/Information';
import Confirmation from './Confirmation/Confirmation';
import CalendarInfo from './UI/CalendarInfo/CalendarInfo';

import * as actions from '../../store/actions/index';
import { useMobile } from '../../store/utility';

import classes from './Schedule.css';

class Schedule extends React.Component{

    stepControl = {
        'calendar': 'calendar',
        'information': 'information',
        'confirmation': 'confirmation',
    }

    constructor(props) {
        super(props);
        this.state = {
            currentStep: this.stepControl.calendar,
        }
      }

    handlePick = (selected_availability) => {
        this.props.handlePickAction(selected_availability);
    }

    handleSelect = (selected_availability) => {
        this.setState({
            currentStep: this.stepControl.information,
        });
        this.props.handleSelectAction(selected_availability);
        window.scrollTo(0, 0);
    }

    handleBook = (info) => {
        this.setState({
            currentStep: this.stepControl.confirmation,
        });
        this.props.handleBookAction(this.props.calendar_id, this.props.selected_availability, info);
    }

    goBack = () => {
        this.setState({
            currentStep: this.stepControl.calendar,
        });
    }

    componentDidMount() {
        this.props.loadCalendar(this.props.match.params.calendar_id);
    }

    render(){

        let content = null;
        let isMobile = useMobile();
        if (this.state.currentStep===this.stepControl.calendar) {
            content = <Calendar 
                isMobile={isMobile} 
                availabilities={this.props.availabilities} 
                selectCallback={this.handleSelect} 
                pickCallback={this.handlePick} 
                selectedAvailability={this.props.selected_availability} 
                calendarOwnerFirstName={this.props.calendar_meta.first_name}
                calendarNote={this.props.calendar_meta.note}>
            </Calendar>
        }
        else if (this.state.currentStep===this.stepControl.information) {
            content = <Information 
                isMobile={isMobile} 
                bookCallback={this.handleBook} 
                goBack={this.goBack} 
                firstName={this.props.firstName} 
                lastName={this.props.lastName} 
                email={this.props.email} 
                contact_method_options={this.props.calendar_meta.contact_method_options}></Information>
        }
        else if (this.state.currentStep===this.stepControl.confirmation) {
            content = <Confirmation isMobile={isMobile} calendarOwnerFirstName={this.props.calendar_meta.first_name} ></Confirmation>
        }

        let metaTitleContent = 'Schedule - ' + this.props.calendar_meta.first_name + ' ' + this.props.calendar_meta.last_name + ' | BookMeeY '
        let metaDescriptionContent = "This is " + this.props.calendar_meta.first_name + ' ' + this.props.calendar_meta.last_name + "'s schedule page, you can see my availabilities and book a call with me. Keep connected."

        return (
            <div className={classes.Schedule}>
                <Helmet>
                <title>{metaTitleContent}</title>
                <meta name="description" content={metaDescriptionContent} />
                </Helmet>

                <Container>
                <CalendarInfo isMobile={isMobile} calendarOwnerFirstName={this.props.calendar_meta.first_name} calendarBookingSelectedAvailability={this.props.selected_availability}></CalendarInfo>
                { content }
                </Container>

            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        calendar_id: state.schedule.calendar_id,
        calendar_meta: state.schedule.calendar_meta,
        availabilities: state.schedule.availabilities,
        selected_availability: state.schedule.selected_availability,
        // current user information
        firstName: state.auth.firstName,
        lastName: state.auth.lastName,
        email: state.auth.userId,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadCalendar: (calendar_id) => dispatch( actions.scheduleGet(calendar_id) ),
        handlePickAction: (selected_availability) => dispatch( actions.schedulePick(selected_availability) ),
        handleSelectAction: (selected_availability) => dispatch( actions.scheduleSelect(selected_availability) ),
        handleBookAction: (calendar_id, selected_availability, info) => 
            { 
                dispatch( actions.scheduleBook(calendar_id, selected_availability, info) )
            },

    };
};

export default connect( mapStateToProps, mapDispatchToProps ) (Schedule);


// WEBPACK FOOTER //
// ./src/containers/Schedule/Schedule.js